/** Plain words for codes shown on the dispatch / recall / lot balance pages. */
import { humanize } from '../../labels'

export const UNIT_TYPE_LABEL: Record<string, string> = {
  LOT: 'Farmer lot',
  BATCH: 'Batch',
  PACK: 'Pack lot',
  BYPRODUCT: 'By-product',
  REJECT: 'Waste',
  ORPHAN: 'Left over',
}
export const unitTypeLabel = (t: string) => UNIT_TYPE_LABEL[t] ?? humanize(t)

export const STEP_LABEL: Record<string, string> = {
  CLEAN: 'Cleaning',
  DRY: 'Drying',
  DEHULL: 'Dehulling',
  SPLIT: 'Splitting',
  POLISH: 'Polishing',
  GRADE: 'Grading',
  SORT: 'Sorting',
  PACK: 'Packing',
  DELABEL: 'Unpacking',
}
export const stepLabel = (s: string) => STEP_LABEL[s] ?? humanize(s)

export const STREAM_LABEL: Record<string, string> = { MAIN: 'Good', CONV: 'Ordinary' }
export const streamLabel = (s: string | null | undefined) => (s ? (STREAM_LABEL[s] ?? humanize(s)) : '—')

export const SAMPLE_STATUS_LABEL: Record<string, string> = {
  SEALED: 'Sealed',
  IN_STORE: 'In the sample store',
  SENT_TO_LAB: 'Sent to lab',
  TESTED: 'Tested',
  DISPOSED: 'Disposed',
}
export const sampleStatusLabel = (s: string) => SAMPLE_STATUS_LABEL[s] ?? humanize(s)

export const DISPATCH_STATUS_LABEL: Record<string, string> = {
  IN_TRANSIT: 'On the road',
  RECEIVED: 'Delivered',
  RECEIVED_SHORT: 'Delivered short',
}
export const dispatchStatusLabel = (s: string) => DISPATCH_STATUS_LABEL[s] ?? humanize(s)
